// This enum should be keep in sync with their native equivalents with the same name
export var RewardAdPluginEvents;
(function (RewardAdPluginEvents) {
    /**
     * Emits when the SDK records a click on a rewarded ad.
     */
    RewardAdPluginEvents["adClicked"] = "onRewardedVideoAdClicked";
    /**
     * Emits when a rewarded ad has loaded and is ready to show.
     */
    RewardAdPluginEvents["Loaded"] = "onRewardedVideoAdLoaded";
    /**
     * Emits when a rewarded ad fails to load.
     */
    RewardAdPluginEvents["FailedToLoad"] = "onRewardedVideoAdFailedToLoad";
    /**
     * Emits when a rewarded ad is shown.
     */
    RewardAdPluginEvents["Showed"] = "onRewardedVideoAdShowed";
    /**
     * Emits when a loaded rewarded ad fails to show.
     */
    RewardAdPluginEvents["FailedToShow"] = "onRewardedVideoAdFailedToShow";
    /**
     * Emits when a rewarded ad is dismissed.
     *
     * This event does not indicate whether the user earned a reward. Listen for
     * `Rewarded` separately before granting the reward.
     */
    RewardAdPluginEvents["Dismissed"] = "onRewardedVideoAdDismissed";
    /**
     * Emits when the user earns the advertised reward.
     */
    RewardAdPluginEvents["Rewarded"] = "onRewardedVideoAdReward";
    /**
     * Emits impression-level ad revenue data when a paid event is recorded.
     */
    RewardAdPluginEvents["AdImpression"] = "onRewardedVideoAdImpression";
})(RewardAdPluginEvents || (RewardAdPluginEvents = {}));
//# sourceMappingURL=reward-ad-plugin-events.enum.js.map